import { cBigNumber } from "../../../classes/BigNumber";
import { tTokenInfo } from "../../../interfaces/interfaces";
import { store } from "../../../store/store"
import { getCurrentPriceQuery, getPricePools } from "./queries";


export const getComissionTokenPrice = async (uTokenAddress: string) => {
	const { params } = store.getState().chromia;
	if (!params) throw new Error();

	const pricePools = await getPricePools();

	// const fToken = 'a8f34e038357c843eb4e87f8debb8c880125eb4e801bbaccc4279fca74102f7f';	// fix

	const commissionPool = pricePools.find(pool => 
		(pool.t0 === uTokenAddress && pool.t1 === params.commissionToken.string) ||
		(pool.t0 === params.commissionToken.string && pool.t1 === uTokenAddress)
	);

	if (!commissionPool) throw new Error();	// show message -?

	// const commissionTokenPrice = await getCurrentPriceQuery(commissionPool.pool, params.commissionToken.string);
	const commissionTokenPrice = await getCurrentPriceQuery(commissionPool.pool, uTokenAddress);
	// console.log('commissionTokenPrice: ', commissionTokenPrice);
	return commissionTokenPrice;
}

export const getTokenPrice = async (fToken: tTokenInfo, uToken: tTokenInfo) => {
	const pricePools = await getPricePools();

	const pool = pricePools.find(pool =>
		(pool.t0 === uToken.address && pool.t1 === fToken.address) ||
		(pool.t0 === fToken.address && pool.t1 === uToken.address)
	);

	if (!pool) throw new Error();	// show message -?

	// const commissionTokenPrice = await getCurrentPriceQuery(commissionPool.pool, params.commissionToken.string);
	const tokenPrice = await getCurrentPriceQuery(pool.pool, uToken.address);
	// console.log(`${fToken.currency}-${uToken.currency} tokenPrice: `, tokenPrice);
	return tokenPrice;
}

export const calculateOrderPrice = (uTokenCurrency: string, orderPrice: cBigNumber, referencePrice: cBigNumber, delta: cBigNumber): cBigNumber => {
	if (delta.isZero()) return orderPrice;

	const tokenPrice = store.getState().app.tokensPrices.find(price => price.currency === uTokenCurrency);
	if (!tokenPrice) throw new Error();

	return orderPrice.add((tokenPrice.price.sub(referencePrice)).mul(delta));
}